import {AuthorizationModel} from "../../authentication/models/authorization-model";
import {AppSettings} from "../../app-settings";
import {prop} from "../../decorators/property";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import {Container} from "aurelia-dependency-injection";
import { AppUser } from "../../authentication/app-user";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

@backboneModelProperties({
    urlRoot: AppSettings.ApiUrlPrefix + "sourcelinksettings/",
    url: AppSettings.ApiUrlPrefix + "sourcelinksettings/",
    idAttribute: "Id",
    relations : [{
        type: Backbone.Many,
        key: "Children",
        relatedModel: SourceLinkSettingsModel
    }],
    defaults : {
        Children: []
    }
})
export class SourceLinkSettingsModel extends AuthorizationModel {

    @prop() public Populated: boolean;
    @prop() public Children: Backbone.Collection<SourceLinkSettingsModel>;
    @prop() public Partial: boolean;
    @prop() public Selected: boolean;
    @prop() public Id: string;
    @prop() public SaveOrganisationSettings: boolean;
    @prop() public CanUsersChangeSettings: boolean;

    private appEvents: Backbone.Events;
    private user: AppUser;

    constructor(options) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.user = ContainerHelper.AuthService.AppUser;
    }

    public loadSettings() {
        if (this.Populated) {
            return Promise.resolve(this);
        }
        return Promise.resolve(this.fetch());
    }

    public remove(): void {
        this.trigger("destroy", this);
    }

    public get UserHasOverrideFlag() {
        return this.user.hasFeatureFlag("SourceLinkOverride");
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/models/source-link-settings.ts